<template>
  <!-- 产品 author: zhangxiaofeng  -->
  <p :class="['flex package-instance', 'level-' + level, isLeaf ? 'instance' : '', borderTop ? 'border-top' : '']">
    <span class="w-410 ellipsis inline-block">
      <i v-if="!isLeaf" :class="[fold ? 'r2-icon-nav_arrow_right' : 'r2-icon-nav_arrow_drop_down']" @click="triggerFold"></i>
      <label :class="{highlight: searchCondition.includes(item.productName)}" @click="triggerFold">{{item.productName || item.merchandiseName}}</label>
    </span>
    <span :class="['flex-1 w-199', forever ? 'font-right' : '']">{{item | formatLimit}}</span>
  </p>
</template>
<style lang="less" type="text/less" scoped>
  .package-instance{
    margin-bottom: 0;
    span.w-410 {
      .highlight {
        padding: 2px 5px;
        background-color: rgba(255, 248, 189, 1);
      }
    }
    &.level-1{
      padding: 4px 0 5px 0;
      span.w-410{
        padding-left: 20px;
        &>i, &>label{ cursor: pointer; }
        i{
          left: -2px;
        }
      }
      &.instance{
        span.w-410{
          padding-left: 5px;
        }
      }
    }
    &.level-2{
      padding: 4px 0 5px 0;
      span.w-410{
        padding-left: 38px;
        &>i, &>label{ cursor: pointer; }
        i{
          left: 16px;
        }
      }
    }
    &.level-3{
      padding: 4px 0 5px 0;
      span.w-410{
        padding-left: 56px;
        &>i, &>label{ cursor: pointer; }
        i{
          left: 34px;
        }
      }
    }
    &.level-4{
      padding: 4px 0 5px 0;
      span.w-410{
        padding-left: 74px;
        &>i, &>label{ cursor: pointer; }
        i{
          left: 52px;
        }
      }
    }
    &.instance{
      span.w-199{
        visibility: visible;
      }
      padding: 4px 0 4px 0!important;
      border-bottom: 1px solid #e6e6e6;
      span.w-410{
        &>i, &>label{ cursor: default!important; }
      }
      &.border-top{
        border-top: 1px solid #e6e6e6;
        margin-top: -1px;
      }
    }
    .t-head{
      span.w-410{
        padding-left: 5px;
      }
    }
    span{
      display: inline-block;
      height: 100%;
      box-sizing: border-box;
      float: left;
      font-size: 14px;
      &.w-410{
        font-size: 14px;
        width: 410px;
        padding-right: 5px;
        height: 25px;
        i{
          position: absolute;
          display: inline-block;
          font-size: 26px;
        }
        label {
          color: rgba(33, 37, 48, 0.8);
        }
      }
      &.w-199{
        color: rgba(33, 37, 48, 0.8);
        font-size: 12px;
        /*width: 199px;*/
        padding: 0 5px;
        visibility: hidden;
        &.show{
          visibility: visible!important;
        }
      }
      &.font-right{
        text-align: right;
      }
    }
  }
</style>
<script>
import {parseTime} from '@/assets/utils'
export default {
  name: 'PackageInstance',
  props: {
    isLeaf: { // 叶子节点
      type: Boolean,
      default: true
    },
    borderTop: {
      type: Boolean,
      default: false
    },
    level: { // 当前是第几级
      type: Number,
      default: 1
    },
    item: {
      type: Object,
      default: () => {}
    },
    searchCondition: { // 产品名称过滤条件
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fold: true // 菜单是否折叠
    }
  },
  computed: {
    forever () {
      let result = false
      if (this.item.limitEndTime === null && this.item.limitStartTime === null) {
        result = true
      }
      return result
    }
  },
  filters: {
    formatLimit (item) {
      let str = ''
      if (item.limitEndTime === null && item.limitStartTime === null) {
        str = '永久'
      } else {
        if (/^\d+$/g.test(item.limitEndTime) && /^\d+$/g.test(item.limitStartTime)) {
          str = '有效期：' + parseTime(item.limitStartTime, '{y}/{m}/{d}') + '~' + parseTime(item.limitEndTime, '{y}/{m}/{d}')
        }
      }
      return str
    }
  },
  methods: {
    triggerFold () {
      if (!this.isLeaf) {
        this.fold = !this.fold
        this.$nextTick(() => {
          this.$emit('foldHandle', this.fold)
        })
      }
    }
  }
}
</script>
